import {
    toast,
    removeMeFromLocalStorage,
} from "../../common/js/libs/common.js";
import { LOGIN_REASON_LOGGED_OUT, loginUrlWithReason } from '../../common/js/core/api/login_reason.js';
import { authApi } from './libs/apis/auth_api.js';

// DOMが完全に読み込まれたときにイベントリスナーを初期化
document.addEventListener("DOMContentLoaded", init);

function init() {
    setupEventListeners();
}

/**
 * 入力エレメントのイベントリスナーを設定する関数
 */
function setupEventListeners() {
    setupLogoutButton();
}

// ログアウトボタン
function setupLogoutButton() {
    const logoutBtn = document.getElementById('logout_btn');
    if (logoutBtn) {
        logoutBtn.addEventListener('click', performLogout);
    }
}

async function performLogout() {
    if (!confirm('本当にログアウトしますか？')) {
        return;
    }

    try {
        const response = await authApi.logout();
        removeMeFromLocalStorage();
        console.log('Success:', response);

        // 文言は渡さず理由コードだけを渡す
        window.location.href = loginUrlWithReason(LOGIN_REASON_LOGGED_OUT);
    } catch (error) {
        toast.error('ログアウトに失敗しました: ' + error.message);
    }
}
